import { gql } from '@apollo/client';

export const GET_DASHBOARD_BTC_CHART = gql`
  query GetDashboardBtcChart(
    $portfolioId: ID!
    $btcSlug: String!
    $historyRange: TimeRange!
    $heatmapDays: Int = 365
  ) {
    transactionHeatmap(portfolioId: $portfolioId, days: $heatmapDays) {
      date
      buyVolume
      sellVolume
    }
    tokenWithPosition(coingeckoSlug: $btcSlug, portfolioId: $portfolioId) {
      token {
        id
        ticker
        priceHistory(timeRange: $historyRange, portfolioId: $portfolioId) {
          time
          price
        }
      }
    }
  }
`;

